import { PropertyInfoInterface } from '../managers/PropertyInfoInterface';
import { GlassFoldUdBox, GroupSelector, KeyValueLine, KeyValueTable, RenderLinkToCompanyGraph, RenderLinkToPersonGraph, ShowSelectedGroup, ViewButtonIcon } from 'src/propertyInfoTemplates/PropertyComponents';
import { ViewButtonCheck } from 'src/propertyInfoTemplates/PropertyComponents';
import { ProtectedFeature } from './ProtectedFeature';
import { PiGraphFill } from 'react-icons/pi';
import { AdvancedDragModal } from 'src/componentsUtils/AdvancedDragModal';
import { useState, useContext, useEffect } from "react";
import { Cookies, Localization, SettingsManager } from '@viamap/viamap2-common';
import { Feature } from 'src/states/ApplicationStateFeatures';
import { GlassButton } from './GlassButtons';
import { windowContext } from 'src/WindowManager/windowContext';
import { openWindow, WindowId } from 'src/WindowManager/WindowState';


type Props = {
   showWindow: number;
   callBackOnClose: () => void;
   cvrNr: number;
   cols?: number;
};
const COOKIE_AutoColapsed = "CompanyAutoColapsed";

export function CompanyInformationDialog(props: Props) {
   const { dispatch: windowDispatch } = useContext(windowContext);
   const [propertyDefaultCollapsed, setPropertyDefaultCollapsed] = useState(Cookies.getCookieBoolean(COOKIE_AutoColapsed))
   const [data, setData] = useState<any>({})

   const [availableGroup, setAvailableGroup] = useState<string[]>([]);
   function setSelectedGroup(string) {
      Cookies.setCookie("CompanyInfoSelectedTab", string)
      _setSelectedGroup(string)
   }

   const [selectedGroup, _setSelectedGroup] = useState(
      Cookies.getCookie("CompanyInfoSelectedTab") || "Alle"
   );

   useEffect(() => {
      if (props.showWindow && props.cvrNr) {
         setData({})
         getDataAsync(props);
      }
   }, [props.showWindow, props.cvrNr])


   async function getDataAsync(props: Props) {
      let cvrNr = props.cvrNr;
      if (!cvrNr) {
         return;
      }

      let cvrData = await PropertyInfoInterface.getCVRSearch({
         "query": {
            "bool": {
               "must": [
                  {
                     "nested": {
                        "path": "Vrvirksomhed.livsforloeb",
                        "query": {
                           "bool": {
                              "must_not": [
                                 {
                                    "exists": {
                                       "field": "Vrvirksomhed.livsforloeb.periode.gyldigTil"
                                    }
                                 }
                              ]
                           }
                        }
                     }
                  }, {
                     "term": { "Vrvirksomhed.cvrNummer": "" + cvrNr }
                  }
               ]
            }
         }
      });
      let keyData = PropertyInfoInterface.extractRelevantData(cvrData);

      let punitData = await PropertyInfoInterface.PEnhederforCVR(cvrNr);

      setData({ ...keyData, punits: punitData });
   }

   if (props.showWindow) {

      function RemberCollapseSettings(val: any) {
         Cookies.setCookieBoolean(COOKIE_AutoColapsed, !val);
      }

      let fold = (
         <div >

            <ViewButtonCheck
               checked={!propertyDefaultCollapsed}
               onCheck={(e, val) => { RemberCollapseSettings(val); setPropertyDefaultCollapsed(!val) }}
            >
               {Localization.getText("Expanded")}
            </ViewButtonCheck>
         </div>
      );

      return (
         <AdvancedDragModal
            title={"Virksomhed"}
            PosDefault={{ width: "800px", height: "calc(100% - 50px)", top: "50px", left: "50%", transform: "translateX(-50%)" }}
            PosDefaultNS={{ width: "calc( 100% - 30px )", height: "calc(100% - 50px)", top: "50px", left: "15px" }}
            saveKey="CompanyInfo"
            onClose={() => props.callBackOnClose()}
            subHeaderContent={
               <>
                  {SettingsManager.getSystemSetting("debuggingShowExtraDebugging") ?
                     <GlassButton onClick={() => console.info(data)} >Log to console</GlassButton>
                     : null}
                  <ProtectedFeature feature={Feature.ExplorerOwnership} contentsIfNoAccess={<></>}>
                     <ViewButtonIcon
                        title={Localization.getText("Show ownership graph")}
                        className="no-print"
                        onClick={() => {
                           windowDispatch(openWindow(WindowId.OwnerShipDiagram, { cvrNr: props.cvrNr }))
                        }}
                     >
                        <PiGraphFill />
                     </ViewButtonIcon>
                  </ProtectedFeature>
                  {fold}</>}
         >
            {/* <ADModalBody> */}
            <GroupSelector
               selected={selectedGroup}
               group={availableGroup}
               onSelect={setSelectedGroup}
            />
            <div className="Scroll-content">
               <ShowSelectedGroup
                  keepSelected={true}
                  loading={false}
                  columns={props.cols!}
                  group={selectedGroup}
                  groupCallBack={(agroups) =>
                     setAvailableGroup([...agroups, "Alle"])
                  }
               >
                  <GlassFoldUdBox
                     group='Virksomhed'
                     title='Virksomhed'
                     foldetUd={!propertyDefaultCollapsed}
                  >
                     <KeyValueLine valKey="Navn" value={data.navn} />
                     <KeyValueLine valKey="CVR" value={data.cvrNummer} />
                     <KeyValueLine valKey="Branchekode" value={data.branchekode} />
                     <KeyValueLine valKey="Branchetekst" value={data.branchetekst} />
                  </GlassFoldUdBox>
                  <GlassFoldUdBox
                     group='Attributter'
                     title='Attributter'
                     foldetUd={!propertyDefaultCollapsed}
                  >
                     <KeyValueTable>
                        {data.attributter && data.attributter.filter((att) => [
                           "FORMÅL",
                           "KAPITAL",
                           "KAPITALVALUTA",
                           "TEGNINGSREGEL",
                           "FØRSTE_REGNSKABSPERIODE_START",
                           "FØRSTE_REGNSKABSPERIODE_SLUT",
                           "VEDTÆGT_SENESTE"].includes(att.type)).map((att, i) => {
                              let formatted: string | undefined = undefined;
                              if ("decimal" == att.vaerditype) {
                                 let float = parseFloat(att.vaerdi)
                                 formatted = new Intl.NumberFormat("da-dk", { minimumFractionDigits: 2 }).format(float);
                              }
                              return (
                                 <tr key={att.type + i}>
                                    <td >
                                       {att.type}
                                    </td>
                                    <td>
                                       {formatted ?? att.vaerdi}
                                    </td>
                                 </tr>
                              );
                           }) || (
                              <tr><td><strong>{Localization.getText("No data")}</strong></td></tr>
                           )}
                     </KeyValueTable>
                  </GlassFoldUdBox>

                  <GlassFoldUdBox
                     group='Ejere'
                     title='Ejere'
                     foldetUd={!propertyDefaultCollapsed}
                  >
                     <KeyValueTable>
                        <tr>
                           <th>Navn</th>
                           <th>CVR-nummer</th>
                           <th>Type</th>
                           <th>Andel</th>
                        </tr>
                        {data.ejere && data.ejere.map((ejer) => {
                           return (
                              <tr key={ejer.forretningsnoegle}>
                                 <td >
                                    {ejer.navn}
                                 </td>
                                 <td>
                                    {ejer.forretningsnoegle ?
                                       // renderCVRLink(ejer.forretningsnoegle)
                                       <RenderLinkToCompanyGraph cvrNr={ejer.forretningsnoegle} />
                                       :
                                       <RenderLinkToPersonGraph cvrPersonId={ejer.cvrPersonId} />
                                    }
                                 </td>
                                 <td >
                                    {(ejer.enhedstype || "").replace("ANDEN_DELTAGER", "UDENLANDSK_AKTØR")}
                                 </td>
                                 <td>
                                    {ejer.andel + "%"}
                                 </td>
                              </tr>
                           );
                        }) || (
                              <tr><td><strong>{Localization.getText("No data")}</strong></td></tr>
                           )}
                     </KeyValueTable>
                  </GlassFoldUdBox>

                  <GlassFoldUdBox
                     group='Produktions Enheder'
                     title='Produktions Enheder'
                     foldetUd={!propertyDefaultCollapsed}
                  >
                     <KeyValueTable>
                        <tr>
                           <th>Adresse</th>
                           <th>Kontaktopl</th>
                           <th>Ansatte</th>
                           <th>Årsværk</th>
                        </tr>
                        {data.punits && data.punits.map((unit) => {
                           return (
                              <tr key={unit.id}>
                                 <td >
                                    {unit.adresse}
                                 </td>
                                 <td>
                                    {unit.kontaktoplysninger.reduce((result, txt, idx) => result + (idx > 0 ? ", " : "") + txt, "")}
                                 </td>
                                 <td>
                                    {unit.beskaeftigelseKvt?.antalAnsatte || unit.beskaeftigelseAar?.antalAnsatte || ""}
                                 </td>
                                 <td>
                                    {unit.beskaeftigelseKvt?.antalAarsvaerk || unit.beskaeftigelseAar?.antalAarsvaerk || ""}
                                 </td>
                              </tr>
                           );
                        }) || (
                              <tr><td><strong>{Localization.getText("No data")}</strong></td></tr>
                           )}
                     </KeyValueTable>
                  </GlassFoldUdBox>

               </ShowSelectedGroup>
            </div>
            {/* </ADModalBody> */}
         </AdvancedDragModal>
      );
   } else {
      return null;
   }

}
